module.exports = __webpack_public_path__ + "static/media/favicon.bb066e37.png";